module.exports = {
  "OEbranch": "master",
  "AIBase": "zh_cn",
  "filePath": "/src/locales",
  "moduleName": "H5-global-fe-cs-workbench-cs-workbench-frame",
  "version": 519,
  "script": "//img0.didiglobal.com/static/copywriter_h5/H5-global-fe-cs-workbench-cs-workbench-frame/src/locales/all.js",
  "prefix": "cs-micro-front-end---",
  "noParse": false
}